import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Agency from '../../agencies/components/Agency';
import { IdPropType } from '../../../proptypes/basic';
import { useCareNeed } from '../careNeedsSlice';
import {
    makeNurseDeploymentsByCareNeedIdSelector,
    useNurseDeploymentsByCareNeedId,
} from '../../nurseDeployments/nurseDeploymentsSlice';
import { useMakeSelector } from '../../store/hooks';
import DisplayDate from '../../date/components/DisplayDate';

const CareNeedDeploymentLoader = ({ careNeedId }) => {
    useNurseDeploymentsByCareNeedId(careNeedId);
    return null;
};

const CareNeed = ({ careNeedId, withoutAgencies, fetch }) => {
    const [careNeed] = useCareNeed(careNeedId);
    const deployments = useMakeSelector(makeNurseDeploymentsByCareNeedIdSelector, careNeedId);

    // agencies of older deployments that aren't the BK-Bedarf's agency - legacy data
    // from before 1 BK-Bedarf = 1 Agentur, still shown until it's cleaned up
    const otherAgencyIds = React.useMemo(
        () =>
            (deployments || []).reduce((carry, deployment) => {
                if (
                    deployment.agencyId &&
                    deployment.agencyId !== careNeed?.agencyId &&
                    !carry.includes(deployment.agencyId)
                ) {
                    carry.push(deployment.agencyId);
                }
                return carry;
            }, []),
        [deployments, careNeed]
    );

    return careNeed ? (
        <Typography variant="inherit">
            {fetch && <CareNeedDeploymentLoader careNeedId={careNeedId} />}
            BK-Bedarf ab <DisplayDate value={careNeed.careFrom} /> {careNeed.careTill && 'bis'}{' '}
            <DisplayDate value={careNeed.careTill} />
            {!withoutAgencies && (
                <>
                    {' · '}
                    {careNeed.agencyId ? (
                        <strong>
                            Agentur <Agency agencyId={careNeed.agencyId} />
                        </strong>
                    ) : (
                        <em>noch keine Agentur</em>
                    )}
                    {otherAgencyIds.length > 0 && (
                        <>
                            {' (ältere Einsätze auch: '}
                            {otherAgencyIds.map((agencyId, index) => (
                                <React.Fragment key={agencyId}>
                                    <Agency agencyId={agencyId} />
                                    {index !== otherAgencyIds.length - 1 && ', '}
                                </React.Fragment>
                            ))}
                            )
                        </>
                    )}
                </>
            )}
        </Typography>
    ) : null;
};

CareNeed.propTypes = {
    careNeedId: IdPropType.isRequired,
    fetch: PropTypes.bool,
    withoutAgencies: PropTypes.bool,
};

CareNeed.defaultProps = {
    fetch: false,
    withoutAgencies: false,
};

export default CareNeed;
